/**
 * What a SkeletonModifier3D type hands the Skeleton3D pass: a reader from its node to the pose edit
 * it makes, and the view of the scene around the skeleton that the edit may read.
 */
/** The reader of a type with no effect on the pose: Godot gives it no edit to run. */
export const noPoseEdit = () => null;
//# sourceMappingURL=poseModifier.js.map